import React__default from 'react';
import { useDeepCompareEffect } from './useDeepCompareEffect.js';
import { useWindowSize } from './useWindowSize.js';
var breakpoints = [768, 1024, 1280];
var useBreakpointValue = function useBreakpointValue(_values) {
  var _a = React__default.useState(_values),
    values = _a[0],
    setValues = _a[1];
  var width = useWindowSize().width;
  useDeepCompareEffect(function () {
    setValues(_values);
  }, [_values]);
  return React__default.useMemo(function () {
    if (!Array.isArray(values)) {
      return values;
    }
    if (width < breakpoints[0]) {
      return values[0];
    }
    if (width < breakpoints[1]) {
      return values[1] || values[0];
    }
    if (width < breakpoints[2]) {
      return values[2] || values[1] || values[0];
    }
    return values[3] || values[2] || values[1] || values[0];
  }, [values, width]);
};
export { useBreakpointValue };